import SmoothScroll from "@/components/landing/SmoothScroll";
import Seo from "@/components/Seo";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Problem from "@/components/landing/Problem";
import Stack from "@/components/landing/Stack";
import Whitepaper from "@/components/landing/Whitepaper";
import MembersGet from "@/components/landing/MembersGet";
import Faq from "@/components/landing/Faq";
import JoinCta from "@/components/landing/JoinCta";
import Footer from "@/components/landing/Footer";
import StickyApplyCta from "@/components/landing/StickyApplyCta";
import { Toaster } from "@/components/ui/sonner";

export default function Landing() {
	return (
		<SmoothScroll>
                        <Seo
                                title="Natant — AI-Native Business OS for the Enterprise"
                                description="Natant designs, runs and tunes your whole business from intent — one AI-native Business OS connecting every floor of the organisation, from CRM to service desk."
                                path="/"
                        />
			<div className="noise-layer" aria-hidden />
			<Nav />
			<main>
				<Hero />
				<Problem />
				<Stack />
                                <MembersGet />
                                <Whitepaper />
                                <JoinCta />
                                <Faq />
			</main>
			<Footer />
			<StickyApplyCta />
			<Toaster
				position="bottom-center"
				toastOptions={{
					style: {
						background: "var(--bone)",
						color: "var(--obsidian)",
						border: "1px solid var(--border-strong)",
					},
				}}
			/>
		</SmoothScroll>
	);
}
